import { PageHeader } from "@/components/kit";
import { MaintenanceManager } from "@/components/Maintenance";
import { PROFILES } from "@/data/mock";

export default function OwnerMaintenance() {
  const { companyId, name } = PROFILES.empresaria;
  return (
    <div data-testid="owner-maintenance-page">
      <PageHeader eyebrow="Manutenção" title="Manutenção da empresa" subtitle="Defina a responsável, cadastre os itens e acompanhe as verificações feitas pela equipe." />
      <MaintenanceManager companyId={companyId} actor={name} />
    </div>
  );
}
